export default __webpack_public_path__ + "63a6e0ccb5577e0dc251698aa2fe45bb.svg";